<div class="row row-responsive justify-content-center">
  @if(!showError)
  {
  <div class="col-lg-12">
    <header class="main-header text-center">
      <div class="row">
        <div class="offset-md-1 col-md-10">
          <h1 class="main-h1 fade-up">{{'welcomeHeader' | translate}} <strong
              class="text-gradient">TeamTransfer</strong></h1>
          <span class="header-intro fade-up">
            {{'headerIntro' | translate }}
          </span>
        </div>
      </div>

      <div class="home-buttons-wrapper">
        <button class="big-button upload" routerLink="/person-create" [state]="{rights: 'Upload'}"
          routerLinkActive="active-link">
          <span class="icon-image">
            <img src="/public/images/upload-icon.svg" />
          </span>
          <div class="button-text">
            <h2><!--{{ 'personOverview.createPerson' | translate }} {{'upload' | translate }}-->
              {{'uploadToTeamsFolder' | translate }} <strong>{{'upload' | translate }}</strong> {{'uploadToTeamsFolder-end' | translate }} </h2>
            <span>{{ 'uploadToTeamsFolderSub-2'| translate}}</span>
          </div>
        </button>
    
        <button class="big-button download" routerLink="/person-create" [state]="{rights: 'Download'}"
          routerLinkActive="active-link">
          <span class="icon-image">
            <img src="/public/images/download-icon.svg" />
          </span>
          <span class="button-text">
            <h2><!--{{ 'personOverview.createPerson' | translate }} {{'download' | translate
              }}--> {{'downloadFromTeamsFolder' | translate }} <strong>{{'download' | translate }}</strong> {{'downloadFromTeamsFolder-end' | translate }}</h2>
            <span>{{ 'downloadFromTeamsFolderSub-2'| translate}}</span>
          </span>
        </button> 
      </div>
    </header>

    <br /><br />
    <h2><strong>{{'ongoing' | translate}}</strong> {{'transfers' | translate}}</h2>
    <mat-card>
      <!--  <mat-card-header class="row">
        <div class="col-md">
          <mat-card-title>{{ 'personOverview.title' | translate }}</mat-card-title>
         <mat-card-subtitle>{{ 'personOverview.subText' | translate }}</mat-card-subtitle>
        </div>
      </mat-card-header>-->
      <mat-card-content>

        @if (loading) {
        <mat-spinner></mat-spinner>
        } @else {
        <div class="table-responsive">

          <!-- <div class="d-flex" style="display: flex;justify-content:space-between;gap: 40px;">
            <span style="align-self: flex-start;"></span>
            <mat-form-field appearance="outline" style="margin-top: 10px;max-width:360px;">
              <mat-icon matSuffix>mode_edit</mat-icon>
              <mat-label>Filter</mat-label>
              <input matInput (keyup)="applyFilter($event)" [placeholder]="'searchPerson' | translate">
            </mat-form-field>
          </div> -->

          <table mat-table [dataSource]="validTransfers">
            <ng-container matColumnDef="firstname">
              <th mat-header-cell *matHeaderCellDef> {{ 'name' | translate }} </th>
              <td mat-cell *matCellDef="let person">
                @if(person.rights === 'Upload') {
                <img src="/public/images/upload.svg" width="16" style="margin-right: 8px;transform: translateY(6px);" />
                } @else {
                <img src="/public/images/download.svg" width="16" style="margin-right: 8px;transform: translateY(6px);" />
                }
                <span>{{person.firstName}} {{person.lastName}}</span>
              </td>
            </ng-container>
            <!--
            <ng-container matColumnDef="lastname">
              <th mat-header-cell *matHeaderCellDef> {{ 'lastName' | translate }} </th>
              <td mat-cell *matCellDef="let person"> {{person.lastName}} </td>
            </ng-container>
            -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> {{ 'send-to' | translate }} </th>
              <td mat-cell *matCellDef="let person"> {{person.email}} </td>
            </ng-container>

            <!--
            <ng-container matColumnDef="rights">
              <th mat-header-cell *matHeaderCellDef>{{ 'personOverview.rights' | translate }} </th>
              <td mat-cell *matCellDef="let person"><span class="d-flex">
                  @if(person.rights === 'Upload') {
                  <img src="/public/images/upload.svg" width="16" style="margin-right: 8px;" />
                  } @else {
                  <img src="/public/images/download.svg" width="16" style="margin-right: 8px;" />
                  }
               {{person.rights}}</span></td>
            </ng-container>-->
            
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let person"><span class="badge success">{{'status.'+person.lastStatus |
                  translate}} </span></td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell class="text-right" *matHeaderCellDef> {{"personOverview.expiryDate" | translate }}
              </th>
              <td mat-cell class="text-right" *matCellDef="let person">
                {{ person.lastTokenEndDate | daysDifference:language }}
              </td>
            </ng-container>

            <ng-container matColumnDef="folder">
              <th mat-header-cell *matHeaderCellDef> {{ 'personOverview.folder' | translate }} </th>
              <td mat-cell *matCellDef="let person">
                <i class="fa-regular fa-folder-open folder-color"></i>
                @if(person.folder) {
                {{ person.folder }}
                } @else {
                -
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="remove">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let person" class="text-end">

                <button mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" aria-label="Menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openConfirmDialog(person.guid)"><mat-icon
                      tabindex="0">delete</mat-icon> {{ 'personOverview.delete' | translate }}</button>
                </mat-menu>

              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['/person-edit', row.guid]">
            </tr>
            <!-- Indien er geen personen zijn -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" style="text-align: center;" [attr.colspan]="displayedColumns.length">
                {{ 'personOverview.noPerson' | translate }}
              </td>
            </tr>
          </table>
        </div>
        }

      </mat-card-content>
    </mat-card>

    <br /><br />
    <h2><strong>{{'expired' | translate}}</strong> {{'transfers' | translate}}</h2>
    <mat-card class="mb-2 opacity-50">
      <mat-card-content>

        @if (loading) {
        <mat-spinner></mat-spinner>
        } @else {
        <div class="table-responsive">
          <table mat-table [dataSource]="expiredTransfers">
            <ng-container matColumnDef="firstname">
              <th mat-header-cell *matHeaderCellDef> {{ 'name' | translate }} </th>
              <td mat-cell *matCellDef="let person">
                @if(person.rights === 'Upload') {
                <img src="/public/images/upload.svg" width="16" style="margin-right: 8px;transform: translateY(6px);" />
                } @else {
                <img src="/public/images/download.svg" width="16" style="margin-right: 8px;transform: translateY(6px);" />
                }
                <span>{{person.firstName}} {{person.lastName}} </span>
              </td>
            </ng-container>
            <!--
            <ng-container matColumnDef="lastname">
              <th mat-header-cell *matHeaderCellDef> {{ 'lastName' | translate }} </th>
              <td mat-cell *matCellDef="let person"> {{person.lastName}} </td>
            </ng-container>
            -->
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef> {{ 'send-to' | translate }} </th>
              <td mat-cell *matCellDef="let person"> {{person.email}} </td>
            </ng-container>
            <!--
            <ng-container matColumnDef="rights">

              <th mat-header-cell *matHeaderCellDef>{{ 'personOverview.rights' | translate }} </th>
              <td mat-cell *matCellDef="let person"><span class="d-flex"> @if(person.rights === 'Upload') {
                

            </ng-container>-->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef> Status </th>
              <td mat-cell *matCellDef="let person"><span class="badge success">{{'status.'+person.lastStatus |
                  translate}} </span></td>
            </ng-container>
            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef> {{"personOverview.expiryDate" | translate }} </th>
              <td mat-cell *matCellDef="let person">
                {{ person.lastTokenEndDate | daysDifference:language }}
              </td>
            </ng-container>


            <ng-container matColumnDef="folder">
              <th mat-header-cell *matHeaderCellDef> {{ 'personOverview.folder' | translate }} </th>
              <td mat-cell *matCellDef="let person">
                <i class="fa-regular fa-folder-open folder-color"></i>

                @if(person.folder) {
                {{ person.folder }}
                } @else {
                -
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="remove">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let person" class="text-end">

                <button mat-icon-button (click)="$event.stopPropagation()" [matMenuTriggerFor]="menu" aria-label="Menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openConfirmDialog(person.guid)"><mat-icon
                      tabindex="0">delete</mat-icon> {{ 'personOverview.delete' | translate }}</button>
                </mat-menu>

              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" [routerLink]="['/person-edit', row.guid]">
            </tr>
            <!-- Indien er geen personen zijn -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" style="text-align: center;" [attr.colspan]="displayedColumns.length">
                {{ 'personOverview.noPerson' | translate }}
              </td>
            </tr>
          </table>
        </div>
        }

      </mat-card-content>
    </mat-card>

  </div>
  }
  @else{
    <div class="site-wrapper center-center">
      <div class="empty-state fade-up">
        <img src="/public/images/forbidden-image.svg">
        <br/>
        <h2>{{ 'error.login.title' | translate }}</h2>
        <p>{{ 'error.login.content' | translate }}</p>
      </div>
  </div>
  }
</div>